import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'

import Routers from './Routers'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Routers />)
